import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Translation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { useForm, Form, Field, useWatch } from '../../form'
import { NumberInput } from '../../utils/numberFormat'
import { getTaxCard, updateTaxCard } from '../../actions'
import { taxValidate } from '../../containers/validate'
import DateTimeFormat from '../../utils/DateTimeFormat'

const styles = (theme) => ({
  mainContainer: {
    marginTop: theme.spacing(1)
  },
  button: {
    //margin: '35px auto',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    float: 'right',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  inputField: {
    width: '25%',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginRight: '0px',
      width: '100%'
    }
  },
  resize: {
    fontSize: '14px'
  },
  progress: {
    flexGrow: 1
  },
  inputContainer: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  hidden: {
    display: 'none'
  }
})

export const defaultValues = {
  withholdingPercentage: '',
  additionalPercentage: '',
  startingBalance: 0,
  incomeLimit: '',
  isOverIncomeLimit: false,
  validFrom: new Date(`${new Date().getFullYear()}-02-01`)
}

const Tax = ({
  showSpinner,
  showTaxCardSnackbar,
  showTaxCardErrorSnackbar,
  closeTaxCardSnackbar,
  closeTaxCardErrorSnackbar,
  classes,
  userType,
  selectedUser,
  noTaxCardFound
}) => {
  const form = useForm({
    name: 'tax',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false,
    validator: taxValidate
  })

  const dispatch = useDispatch()

  const {
    control,
    formState: { isSubmitting }
  } = form

  function onSubmit(values) {
    const submitValues = { startingBalance: values.startingBalance }
    dispatch(updateTaxCard(submitValues))
  }

  useEffect(() => {
    dispatch(getTaxCard())
  }, [])

  const watch = useWatch({
    fields: ['isOverIncomeLimit', 'validFrom'],
    control
  })

  return (
    <Translation>
      {(t) => {
        return (
          <div style={{ maxWidth: '1000px' }}>
            <div className="container-fluid">
              <div>
                <div className="dashboard-content-header">
                  <h1>{t('taxComponent.h3')}</h1>
                </div>
              </div>
              <div>
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div>
                      <div className="panel-body">
                        <div
                          className={classes.mainContainer}
                          style={{ fontWeight: 600 }}
                        >
                          <p>{t('taxComponent.info')}</p>
                          <p>
                            {t('taxComponent.info2_1') +
                              new DateTimeFormat('fi', {
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric'
                              }).format(new Date(watch.validFrom)) +
                              t('taxComponent.info2_2')}
                          </p>
                          <Form {...form}>
                            <div className={classes.inputContainer}>
                              <div className={classes.inputField}>
                                <Field
                                  name="startingBalance"
                                  label={t('taxComponent.startingBalance')}
                                  inputType="textfield"
                                  inputComponent={CurrencyInput}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className={classes.inputField}>
                                <Field
                                  name="incomeLimit"
                                  label={t('taxComponent.incomeLimit')}
                                  disabled={true}
                                  inputType="textfield"
                                  inputComponent={CurrencyInput}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className={classes.inputField}>
                                <Field
                                  name="withholdingPercentage"
                                  label={
                                    t('taxComponent.withholdingPercentage') +
                                    (!watch.isOverIncomeLimit
                                      ? t('taxComponent.active')
                                      : '')
                                  }
                                  labelStyle={{
                                    whiteSpace: 'nowrap'
                                  }}
                                  disabled={true}
                                  inputType="textfield"
                                  inputComponent={PercentageInput}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className={classes.inputField}>
                                <Field
                                  name="additionalPercentage"
                                  label={
                                    t('taxComponent.additionalPercentage') +
                                    (watch.isOverIncomeLimit
                                      ? t('taxComponent.active')
                                      : '')
                                  }
                                  labelStyle={{
                                    whiteSpace: 'nowrap'
                                  }}
                                  disabled={true}
                                  inputType="textfield"
                                  inputComponent={PercentageInput}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                            </div>
                            <Field
                              name="isOverIncomeLimit"
                              disabled={true}
                              inputType="checkbox"
                              control={control}
                              className={classes.hidden}
                            />
                            <Field
                              name="validFrom"
                              disabled={true}
                              inputType="datepicker"
                              control={control}
                              hidden={true}
                            />
                            <div>
                              <Button
                                variant="contained"
                                className={classes.button}
                                disabled={
                                  isSubmitting ||
                                  (userType == 2 &&
                                    selectedUser.email == undefined)
                                    ? true
                                    : false
                                }
                                type="submit"
                              >
                                {t('taxComponent.save')}
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </div>
                      <div className="panel-body" style={{ fontWeight: 600 }}>
                        <p className="dashboard-tax-address">
                          {t('taxComponent.taxFailInfo1')}
                        </p>
                        <p className="dashboard-tax-address">
                          {t('taxComponent.taxFailInfo2')}{' '}
                          <a href="mailto: asiakaspalvelu@invosy.com">
                            {t('taxComponent.email')}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showTaxCardSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeTaxCardSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeTaxCardSnackbar()
                }}
                variant="success"
                message={t('taxComponent.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showTaxCardErrorSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeTaxCardErrorSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeTaxCardErrorSnackbar()
                }}
                variant="error"
                message={
                  noTaxCardFound
                    ? t('taxComponent.noTaxCardFound')
                    : t('taxComponent.msg2')
                }
              />
            </Snackbar>
            <Dialog
              open={showSpinner}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('taxComponent.title')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const CurrencyInput = (props) => {
  return <NumberInput {...props} decimalScale={2} suffix=" €" />
}

const PercentageInput = (props) => {
  return (
    <NumberInput
      {...props}
      decimalScale={2}
      fixedDecimalScale={true}
      suffix=" %"
    />
  )
}

Tax.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Tax)
